import React, { useEffect, useState } from 'react'
import isNull from '../../../../../../../../../../../utils/NullChecking'
import { ServerRequestProtected } from '../../../../../../../../../../../utils/ServerDataRequest';
import NotificationHandler from '../../../../../../../../../../../utils/NotificationHandler';
import { enumUtil } from '../../../../../../../../../../../utils/Enum';
import FormValidator from '../../../../../../../../../../../utils/FormValidator';
import { Modal, ModalBody } from "react-bootstrap";
import DatePicker from '../../../../../../../../../../General/DatePicker';
import ModalHeader from '../../../../../../../../../../Setup/Shared/ModalHeader';
import SuperSearchList from '../../../../../../../../../../shared/SuperSearch/SuperSearchList';
import { useSelector } from 'react-redux';
import Loader from '../../../../../../../../../../shared/Loader/Loader';
import DeleteConfirmatiom from '../../../../../../../../../../General/DeleteConfirmation';

const StatusData = [
  { display: '', value: '' },
  { display: 'Active', value: 'Active' },
  { display: 'In Active', value: 'In Active' },
];
const MedicalDevicesData = [
  { display: 'Pacemaker', value: 'Pacemaker' },
  { display: 'Cochlear Implant', value: 'CochlearImplant' },
  { display: 'Artificial Joint', value: 'ArtificialJoint' },
  { display: 'Spinal Cord Stimulator', value: 'SpinalCordStimulator' },
  { display: 'Neurostimulator', value: 'Neurostimulator' },
  { display: 'Cardiac Defibrillator', value: 'CardiacDefibrillator' },
  { display: 'Intraocular Lens', value: 'IntraocularLens' },
  { display: 'Vascular Stent', value: 'VascularStent' },
  { display: 'Artificial Heart Valve', value: 'ArtificialHeartValve' },
  { display: 'Dental Implant', value: 'DentalImplant' },
  { display: 'Breast Implant', value: 'BreastImplant' },
  { display: 'Insulin Pump', value: 'InsulinPump' },
  { display: 'Orthopedic Implant', value: 'OrthopedicImplant' },
  { display: 'Dialysis Access Device', value: 'DialysisAccessDevice' },
];

const AddNewImplantableDevices = ({ setIsRecordSaved, ...props }) => {
  const { isOpenImplantableDevices, onClose, onDeleteImplantableDevices } = { ...props }
  let { patientID, IsEditAllowed } = props;
  // let PatientIDR = useSelector(state => state.Open_Patient_Tab.find((pt) => pt.active === true)).data?.id;
  const API_URL = enumUtil.controller.General
  let ImplantableDevices_Modal = {
    DeviceName: "",
    OnSetDate: "",
    ImplantableDeviceStatus: "",
  }
  let valModal = {}
  let ValidationModal = {
    DeviceNameVal: "",
    OnSetDateVal: "",
    ImplantableDeviceStatusVal: "",
  }
  const [isOpenDeleteAlert, setisOpenDeleteAlert] = useState(false);
  const [deviceNameSelected, setDeviceNameSelected] = useState(false);
  const [isEdit, setIsEdit] = useState(true)
  const [implantableDevicesID, setImplantableDevicesID] = useState();
  const [implantableDevicesValidationModal, setImplantableDevicesValidationModal] = useState(ValidationModal)
  const [implantableDevicesSaveUpdateModal, setImplantableDevicesSaveUpdateModal] = useState({})
  const [mainImplantableDevicesModal, setMainImplantableDevicesModal] = useState(ImplantableDevices_Modal);
  const [isLoading, setIsLoading] = useState(false)
  const [onImplantableDevicesSaved, setOnImplantableDevicesSaved] = useState(false)
  const [del, setDel] = useState(false)
  const [searchDropdown, setSearchDropdown] = useState(false);
  const [is, setIs] = useState(false);
  const [deviceNameBody, setDeviceNameBody] = useState({ "TableName": enumUtil.enumAPITableName.PatientImplantableDevice, "SearchParam": '' })
  console.log("AddNewProblem", props);
  useEffect(() => {
    // setPracticeID(PracticeID)
    if (props.implantableDevicesID != null) {
      setDel(true)
      setImplantableDevicesID(props.implantableDevicesID)
    } else {
      if (!onImplantableDevicesSaved) {
        setImplantableDevicesID(0);
        setDel(false)
      } else {
        setDel(true)
      }
    }
    if (!isNull(implantableDevicesID)) {
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/FindByID", 'post', {
        "ID": implantableDevicesID,
        "TableName": enumUtil.enumAPITableName.PatientImplantableDevice
      }).then((response) => {
        setIsLoading(false)
        setIsEdit(false);
        setDeviceNameSelected(true);
        setIs(true);
        setMainImplantableDevicesModal(response);
      }).catch((error) => {
        NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        setIsLoading(false)
      })
    }
  }, [implantableDevicesID])

  const ImplantableDevicesValidation = async () => {
    let ValidationModal = {
      DeviceNameVal: FormValidator(
        mainImplantableDevicesModal.DeviceName,
        enumUtil.enumValidationType.Required,
        'Device Name',
      ),
      OnSetDateVal: FormValidator(
        mainImplantableDevicesModal.OnSetDate,
        enumUtil.enumValidationType.Required,
        'OnSet Date',
      ),
      ImplantableDeviceStatusVal: FormValidator(
        mainImplantableDevicesModal.ImplantableDeviceStatus,
        enumUtil.enumValidationType.Required,
        'Status',
      ),
    }
    await setImplantableDevicesValidationModal(ValidationModal)
    valModal = ValidationModal
  }
  const addNewImplantableDevices = () => {
    props.setImplantableDevicesID(null);
    setImplantableDevicesID(null)
    handleClear();
  }
  const handleSaveImplantableDevices = async (type) => {
    if(!IsEditAllowed) return;
    await ImplantableDevicesValidation()
    let validation = FormValidator([valModal], enumUtil.enumValidationType.NullCheck)
    if (validation) {
      NotificationHandler('Fill Required Fields', enumUtil.enumtoaster.error)
      return
    } else {
      setImplantableDevicesSaveUpdateModal(implantableDevicesSaveUpdateModal)
      let saveModal = {
        TableName: enumUtil.enumAPITableName.PatientImplantableDevice,
        ID: implantableDevicesID,
        Data: { PatientID: patientID, ...implantableDevicesSaveUpdateModal },
      }
      setIsLoading(true)
      ServerRequestProtected(API_URL + "/SaveSingleRecord", 'post', saveModal)
        .then((response) => {
          if (!isNull(response.id)) {
            setIsLoading(false)
            NotificationHandler(`Record Saved Successfully`, enumUtil.enumtoaster.success);
            setIsRecordSaved(true);
            if (type === "Add Another") {
              addNewImplantableDevices();
            } else {
              onClose();
            }
            // setImplantableDevicesID(response.id)
            // setOnImplantableDevicesSaved(true)
          }
        }).catch((error) => {
          setIsLoading(false)
          console.log('error', error);
          NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
        })
    }
  }

  const handleClear = () => {
    setMainImplantableDevicesModal(ImplantableDevices_Modal);
    setImplantableDevicesSaveUpdateModal({});
    setIsEdit(true);
    setDeviceNameSelected(false);
  }

  // const handleSetCheckbox = (e) => {
  //   let { name, checked } = e.target
  //   let modal = { ...mainImplantableDevicesModal };
  //   let saveModal = { ...implantableDevicesSaveUpdateModal}
  //   modal[name] = String(checked);
  //   setMainImplantableDevicesModal(modal)
  //   for (var property in ImplantableDevices_Modal) {
  //     if (name === property) {
  //       saveModal[name] = String(checked);
  //     }
  //   }
  //   setImplantableDevicesSaveUpdateModal(saveModal)
  // }
  const handleChange = (e) => {
    let { name, value } = e.target
    let modal = { ...mainImplantableDevicesModal };
    let saveModal = { ...implantableDevicesSaveUpdateModal }
    modal[name] = value
    setMainImplantableDevicesModal(modal)
    for (var property in ImplantableDevices_Modal) {
      if (name === property) {
        saveModal[name] = value
      }
    }
    setImplantableDevicesSaveUpdateModal(saveModal)
  }
  const handleDateChange = (date, type) => {
    var FormatedDate = date
    let modal = { ...mainImplantableDevicesModal };
    let saveModal = { ...implantableDevicesSaveUpdateModal }
    modal[type] = FormatedDate
    setMainImplantableDevicesModal(modal)
    for (var property in ImplantableDevices_Modal) {
      if (type === property) {
        saveModal[type] = FormatedDate
      }
    }
    setImplantableDevicesSaveUpdateModal(saveModal)
  }

  const ImplantableDevicesName = () => {
    return (
      <p className="heading">Add New Implantable Devices</p>
    )
  }
  const handleSelectedData = (selectedData, name, type, mode) => {
    setIs(true)
    let modal = { ...mainImplantableDevicesModal };
    if (type === 'client' && !isNull(selectedData)) {
      if (name === "ImplantableDeviceStatus") {
        modal[name] = selectedData.display
        implantableDevicesSaveUpdateModal[name] = selectedData.value + "";
        // setProviderID(selectedData.value + "")
      } else if (name === "DeviceName") {
        modal[name] = selectedData.display
        implantableDevicesSaveUpdateModal[name] = selectedData.value + "";
        setIsEdit(false);
        // setProviderID(selectedData.value + "")
      }
    } else if (type === 'server' && !isNull(selectedData)) {
      if (name === 'DeviceName') {
        implantableDevicesSaveUpdateModal[name] = String(selectedData.value);
        modal[name] = selectedData.display;
        setIsEdit(false);
        setDeviceNameSelected(true);
      }
    } else {

      modal[name] = ''
      implantableDevicesSaveUpdateModal[name] = ''
      if (name === 'DeviceName') {
        setDeviceNameSelected(false);
      }
    }
    setMainImplantableDevicesModal(modal);
    // setImplantableDevicesSaveUpdateModal(implantableDevicesSaveUpdateModal);
    return selectedData
  }
  const handleDeviceChange = (e) => {
    setIs(false)
    setMainImplantableDevicesModal(prev => ({ ...prev, DeviceName: e.target.value }));
    setDeviceNameBody({ "TableName": enumUtil.enumAPITableName.PatientImplantableDevice, "SearchParam": e.target.value })
  }

  const handleDeleteModal = () => {
    setisOpenDeleteAlert(true)
  }
  const onCloseDelete = () => {
    setisOpenDeleteAlert(false);
  }
  const onDelete = () => {
    setIsRecordSaved(true);
    setisOpenDeleteAlert(false);
    onClose();
  }

  let DeleteConfirmation = "";
  if (isOpenDeleteAlert) {
    DeleteConfirmation = (
      <DeleteConfirmatiom
        isOpenAlert={isOpenDeleteAlert}
        hideReason={true}
        API_URL={API_URL}
        TableName={enumUtil.enumAPITableName.PatientImplantableDevice}
        ID={String(implantableDevicesID)}
        onCloseDelete={onCloseDelete}
        onClose={onDelete}
      />
    );
  }
  let DeletePopup = "";
  if (del) {
    DeletePopup = (
      <button
        className={
          props?.IsDeleteAllowed
            ? 
          "btn-icon-transparent"
            : 
            "btn-icon-transparent delete-btn-disabled"
        } onClick={handleDeleteModal}>
        <span className="icon"><i className="icon-delete"></i></span>
        <span className="title">Delete</span>
      </button>
    );
  }

const handleClearDeviceName = () => {
    let name = 'DeviceName';
    let modal = { ...mainImplantableDevicesModal };
    modal[name] = ''
    implantableDevicesSaveUpdateModal[name] = ''
    implantableDevicesSaveUpdateModal[name + 'ID'] = "";
    if (name === 'DeviceName') {
        setDeviceNameSelected(false);
    }
    setMainImplantableDevicesModal(modal)
    setImplantableDevicesSaveUpdateModal(implantableDevicesSaveUpdateModal)
}
  return (
    <Modal show={isOpenImplantableDevices} onHide={isOpenImplantableDevices} backdrop="static" keyboard={false} centered dialogClassName="hk-modal-v1 ar_ehr_problems ar_new-popup-design">
      <Modal.Body>
        {DeleteConfirmation}
        {isLoading ? <Loader /> : <></>}
        {/* <ModalHeader HeaderName={ImplantableDevicesName} DeletePopup={''} isClosed={onClose} /> */}
        <ModalHeader HideAuditIcon={"PatEncounter"} HeaderName={ImplantableDevicesName} isOpenDeleteAlert={isOpenDeleteAlert} onCloseDelete={onCloseDelete} DeletePopup={DeletePopup} isClosed={onClose} />
        <div className="">
          <div className='patient_payment_tabs'>
            {/* <div className="input my-2"> */}

            {isEdit ?
              <div className={`input claims_info search-icon-icdSearch my-2 ${implantableDevicesValidationModal.DeviceNameVal ? 'error' : ''}`}>
                {(mainImplantableDevicesModal.DeviceName?.length > 0 && deviceNameSelected) ?<i className='ar-cross-icon fs-18 icon-x-cros top-50 translate-middle-y top-50 translate-middle-y ar-light-color' onClick={handleClearDeviceName}></i> : null}
                <div>
                  <SuperSearchList
                    type='server'
                    id='DeviceName'
                    name='DeviceName'
                    searchValue={mainImplantableDevicesModal.DeviceName}
                    ApiLink={API_URL + "/instantSearch"}
                    method='post'
                    postBody={deviceNameBody}
                    onChange={handleDeviceChange}
                    getSelectedData={handleSelectedData}
                    is={is}
                    sup_btn='sup_btn-Inp'
                    sup_inp='superSearchVisitInp'
                    icon={true}
                    disabled={true}
                    placeholder='Search devices here...'
                    inputError={implantableDevicesValidationModal.DeviceNameVal}
                  />
                </div>

                {/* <SuperSearchList
                    type="client"
                    id='DeviceName'
                    name='DeviceName'
                    searchValue={mainImplantableDevicesModal.DeviceName}
                    data={MedicalDevicesData}
                    onChange={handleChange}
                    getSelectedData={handleSelectedData}
                    is={is}
                    sup_btn='sup_btn-Inp'
                    sup_inp='superSearchVisitInp'
                    placeholder='Search existing problems or allergies here...'
                    inputError={implantableDevicesValidationModal.DeviceNameVal}
                /> */}
                {implantableDevicesValidationModal.DeviceNameVal}
              </div> :
              <>
                {mainImplantableDevicesModal.DeviceName &&
                  <div className="mb-2 d-flex align-items-center justify-content-between gap-15 px-1">
                    <p className="text fs-13 font-m ar-dark-color validation_message text-nowrap"> <span className='text-decoration-underline'>{mainImplantableDevicesModal.DeviceName}</span> <span className=''></span></p>
                    <i className='icon-edit-pencil fs-12' onClick={() => setIsEdit(prev => !prev)}></i>
                  </div>
                }
              </>}
            {deviceNameSelected &&
              <>
                <div className="d-flex align-items-end gap-12 mb-12">
                  <div className="mb-0">
                    {/* <label className="pb-3px">Onset Date</label> */}
                    <DatePicker
                      label="Implantation  Date"
                      className={implantableDevicesValidationModal.OnSetDateVal ? 'mb-0 error' : ''}
                      value={mainImplantableDevicesModal.OnSetDate}
                      handleCalendarChangefunc={date => handleDateChange(date, 'OnSetDate')}
                    />
                    {implantableDevicesValidationModal.OnSetDateVal}
                  </div>
                  <div className="form-group input">
                    <label className="pb-3px">Status</label>
                    {/* <div className={'input form-group ar-multiple-br m-0'}> */}
                    <div className={`input form-group ar-multiple-br m-0 ${implantableDevicesValidationModal.ImplantableDeviceStatusVal ? 'error' : ''}`}>
                      <SuperSearchList
                        type="client"
                        id='ImplantableDeviceStatus'
                        name='ImplantableDeviceStatus'
                        searchValue={mainImplantableDevicesModal.ImplantableDeviceStatus}
                        data={StatusData}
                        onChange={handleChange}
                        getSelectedData={handleSelectedData}
                        is={is}
                        sup_btn='sup_btn-Inp'
                        sup_inp='superSearchVisitInp'
                        placeholder="Select Status"
                        inputError={implantableDevicesValidationModal.ImplantableDeviceStatusVal}
                      />
                      {implantableDevicesValidationModal.ImplantableDeviceStatusVal}
                    </div>
                  </div>
                </div>
              </>}
          </div>
        </div>
      </Modal.Body>
      <div className='d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light  ar_footer justify-content-between'>
        <button className='btn btn-outline  px-10 h-100 dark-clr' onClick={onClose}>Cancel</button>
        {/* <button className='btn btn-validate px-10 h-100' onClick={handleSaveImplantableDevices}>Save</button> */}
        <div className="d-flex align-items-center gap-2">
          <button className={`btn btn-outline  px-10 h-100 validate-color ${IsEditAllowed ? '' : 'disable'}`} onClick={() => handleSaveImplantableDevices("Add Another")}>Save & Add Another</button>
          <button className={`btn btn-validate px-10 h-100 ${IsEditAllowed ? '' : 'disable'}`} onClick={handleSaveImplantableDevices}>Save</button>
        </div>
      </div>
    </Modal>
  )
}

export default AddNewImplantableDevices